import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IUserInfo } from '@bashaquerizwan/azaadi-packages';
import { Observable } from 'rxjs';
import { ILoginRequest } from 'src/app/modules/login/model/Loging';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly _loginUrl = environment.authUrl;
  private readonly _http = inject(HttpClient);
  private readonly _userInfoUrl = environment.authApiUrl + '/user-info';

  login(data: ILoginRequest): Observable<HttpResponse<any>> {
    return this._http.post<any>(this._loginUrl, data, { observe: 'response' });
  }

  getUserByToken(token: string) {
    return this._http.post<{ user: IUserInfo }>(this._userInfoUrl, {
      data: {
        sAccessToken: token,
      },
    });
  }
}
